<style src="css/login.css" scoped></style>
<template>
  <div class="bgImg">
    <img class="loginLogo" src="../../assets/common/logo02.jpg"/>
    <div>
      <div class="loginBtn">{{ loginBtnText }}</div>
    </div>
  </div>
</template>
<script>
import {autoLogin} from '@/api/user'

export default {
  data() {
    return {
      loginBtnText: '登录中...'
    };
  },
  computed: {},
  created() {
    const k = this.$utils.getQueryString('k') || this.$route.query.k
    console.log('auto-login k=' + k)
    if (this.$utils.isBlank(k)) {
      this.loginBtnText = '参数错误'
      return
    }
    this.doLogin(k)
  },
  methods: {
    async doLogin(k) {
      let resp = await autoLogin(k);
      this.$utils.storeLoginInfo(resp.data)
      this.$router.push('/')
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/user/auto-login.vue